import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, X, ArrowRight } from 'lucide-react';
import { fallPromoCopy } from '../data/fallSpecial';

// Controlled dismissible top banner. Parent manages visibility so the fixed header can offset correctly.
const PromoBanner = ({ onClose }) => {
  const copy = fallPromoCopy();
  return (
    <div className={`fixed top-0 inset-x-0 z-[55] h-10 bg-gradient-to-r ${copy.theme.banner} text-white flex items-center`} data-testid="promo-banner">
      <div className="max-w-7xl mx-auto w-full pl-4 pr-12 sm:px-6 lg:px-8 flex items-center justify-center relative">
        <Link
          to={copy.path}
          className="flex items-center gap-2 text-xs sm:text-sm font-semibold hover:underline text-center leading-tight"
          data-testid="promo-banner-link"
        >
          <Leaf className="w-4 h-4 shrink-0" />
          <span>{copy.bannerText}</span>
          <ArrowRight className="w-4 h-4 shrink-0 hidden sm:inline" />
        </Link>
        <button
          onClick={onClose}
          aria-label="Dismiss promotion"
          className="absolute right-0 sm:right-2 h-10 w-10 flex items-center justify-center text-white/80 hover:text-white"
          data-testid="promo-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
